module.exports = __webpack_public_path__ + "img/lilac.dd2c37c8.png";